const AdminTickets = () => {
  return (
    <div>Admin Tickets</div>
  )
}

export default AdminTickets